import { Component, OnInit } from '@angular/core';
import { constants } from '../../../environments/constants';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { InputsModule, SwitchModule } from '@progress/kendo-angular-inputs';
import { FormsModule } from '@angular/forms';
import { ContextMenuModule } from '@progress/kendo-angular-menu';
import { LabelModule } from '@progress/kendo-angular-label';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { DialogsModule } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-home',
    imports: [SwitchModule, FormsModule, ContextMenuModule, LabelModule, LayoutModule, CommonModule,
        DialogsModule,
    ],
    templateUrl: './home.component.html',
    styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit {
  version = constants.version;
  body = '';
  url = '';
  userType = false;
  openeWindow = false;
  activeAccount: AccountInfo | null = null;
  constructor(private authService: MsalService) {
    this.activeAccount = this.authService.instance.getActiveAccount();
  }
  ngOnInit(): void {
    this.body = "Dear Support" + "%0D%0A%0D%0A" + "Please enter your request here......" + "%0D%0A"
      + "[provide an explanation and screen prints of the issue you are reporting]" + "%0D%0A%0D%0A" + "Regards"
      + "%0D%0A" + this.activeAccount?.name;
    this.url = "mailto:" + "idocs_support_global@mcdermott.com" + "?subject=iDocsXD Portal Request : " + "[Project Name - Order No.]" + "&body=" + this.body;
  }
  getUserDetails() {
    const domain = this.activeAccount?.username?.split("@")[1];
    if (domain?.toLowerCase() == 'mcdermott.com') {
      window.open(`https://mcdermott.service-now.com/esc_servicedesk?id=sc_cat_item&sys_id=6c9c312013c80c50a75175c36144b097&sysparm_project=Project Name: Order No.&sysparm_subCategory=iDocsXD Portal`, "_blank");
    } else {
      window.location.href = this.url;
    }
  }
  setToggle() {
    if (this.userType) {
      window.location.href = this.url;
    }

  }
  closeAccessWindow() {
    this.openeWindow = false;
  }
}
